module.exports = __webpack_public_path__ + "static/img/photo.ca5a491a.png";